import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full px-4 py-20 md:py-24 bg-ivory" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        {/* Circular badge */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-8" data-id="element-106">
          <div className="relative w-32 h-32 md:w-36 md:h-36 rounded-full border-2 border-clay/70 flex flex-col items-center justify-center bg-cream/40" data-id="element-107">
            <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-clay mb-1" strokeWidth={1.4} data-id="element-108" />
            <span className="font-serif text-base md:text-lg font-bold tracking-widest text-clay" data-id="element-109">
              7 DÍAS
            </span>
          </div>
        </motion.div>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-center font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-10 md:mb-12 px-2" data-id="element-110">
          Mi Garantía de "Cero Riesgo"
        </motion.h2>

        {/* Body card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-cream rounded-3xl px-6 md:px-12 py-10 md:py-14 text-center shadow-[0_30px_80px_-40px_rgba(139,107,73,0.35)]" data-id="element-111">
          <p className="text-lg md:text-xl text-ink/85 leading-relaxed max-w-xl mx-auto" data-id="element-112">
            Prueba la guía durante{' '}
            <span className="font-bold" data-id="element-113">7 días completos</span>. Si después de
            revisarla y aplicar las primeras recomendaciones sientes que no es
            para ti, envíanos un email y te devolvemos cada centavo.
          </p>

          <p className="text-lg md:text-xl font-serif font-bold text-ink mt-8 mb-6" data-id="element-114">
            Sin preguntas, sin resentimientos.
          </p>

          <p className="font-serif italic text-2xl md:text-3xl text-clay" data-id="element-115">
            El riesgo es 100% nuestro.
          </p>
        </motion.div>
      </div>
    </section>;
}